<template>
  <div class="matches-view">
    <div class="view-header">
      <h2>赛程</h2>
      <div class="league-selector">
        <div
          v-for="country in countries"
          :key="country.id"
          class="flag-container"
          :class="{ active: selectedCountry && selectedCountry.id === country.id }"
          @click="selectCountry(country)"
        >
          {{ country.code }}
        </div>
      </div>
    </div>

    <div v-if="loading">Loading matches...</div>
    <div v-if="error">{{ error }}</div>

    <table v-if="matches.length" class="styled-table">
      <thead>
        <tr>
          <th>赛事</th>
          <th>日期</th>
          <th>主队</th>
          <th>比分</th>
          <th>客队</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="match in matches" :key="match.id">
          <td>{{ match.country_name }}</td>
          <td>{{ match.match_date }}</td>
          <td>{{ match.home_team_name }}</td>
          <td class="score">{{ match.home_goals }} - {{ match.away_goals }}</td>
          <td>{{ match.away_team_name }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else-if="0 !== matches.length">
      <p>No matches available for this league.</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { fetchMatchResults, fetchCountries } from '@/api/client.js'

const matches = ref([])
const countries = ref([])
const selectedCountry = ref(null)
const loading = ref(true)
const error = ref(null)

const fetchMatches = async (countryId) => {
  loading.value = true
  error.value = null
  matches.value = []
  try {
    matches.value = await fetchMatchResults(countryId)
  } catch (e) {
    error.value = `Failed to fetch matches for country ID ${countryId}: ${e.message}`
  } finally {
    loading.value = false
  }
}

const selectCountry = (country) => {
  selectedCountry.value = country
  fetchMatches(country.id)
}

onMounted(async () => {
  try {
    countries.value = await fetchCountries()
    if (countries.value.length > 0) {
      // Select the first country by default
      selectedCountry.value = countries.value[0]
      await fetchMatches(selectedCountry.value.id)
    }
  } catch (e) {
    error.value = `Failed to fetch countries: ${e.message}`
  }
})
</script>

<style scoped>
/* Styles remain the same */
.view-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.league-selector {
  display: flex;
  gap: 10px;
}
.flag-container {
  cursor: pointer;
  padding: 5px;
  border: 2px solid transparent;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
}
.flag-container:hover {
  border-color: #3498db;
}
.flag-container.active {
  border-color: #2c3e50;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.flag-container img {
  width: 40px;
  height: auto;
  display: block;
}
.matches-view {
  padding: 20px;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 0.9em;
}
.styled-table thead tr {
  background-color: #2c3e50;
  color: #ffffff;
  text-align: left;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
  text-align: center;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.score {
  font-weight: bold;
}
</style>
